
import { supabase } from "@/integrations/supabase/client";
import { OfferedReagent } from "../types";

/**
 * Handles a swap offer with an existing reagent from the user's inventory
 */
export const handleExistingReagentOffer = async (swapRequestId: string, offeredReagentId: string): Promise<boolean> => {
  try {
    const { data: reagentData, error: reagentError } = await supabase
      .from("reagents")
      .select("*")
      .eq("id", offeredReagentId)
      .single();
      
    if (reagentError) {
      console.warn("Swap request created but failed to fetch offered reagent details");
      return false;
    }
    
    // Insert into offered_reagents table - with proper fields
    const { error: offerError } = await supabase
      .from("offered_reagents")
      .insert({
        swap_request_id: swapRequestId,
        name: reagentData.name,
        catalogue_number: reagentData.catalogue_number,
        description: reagentData.description || "",
        amount: reagentData.amount || 0,
        amount_unit: reagentData.amount_unit || "",
        storage_conditions: reagentData.storage_conditions || ""
      });
      
    if (offerError) {
      console.warn("Swap request created but failed to link offered reagent:", offerError);
      return false;
    }
    
    return true;
  } catch (error) {
    console.warn("Exception in handleExistingReagentOffer:", error);
    return false;
  }
};

/**
 * Handles a swap offer with a new reagent offered by the user
 */
export const handleNewReagentOffer = async (
  swapRequestId: string, 
  offeredReagent: OfferedReagent | undefined
): Promise<boolean> => {
  if (!offeredReagent) return false;
  
  const { name, catalogNumber, amount, unit, storageConditions, description } = offeredReagent;
  
  const { error: reagentError } = await supabase
    .from("offered_reagents")
    .insert({
      swap_request_id: swapRequestId,
      name,
      catalogue_number: catalogNumber,
      description,
      amount: parseFloat(amount),
      amount_unit: unit,
      storage_conditions: storageConditions
    });
    
  if (reagentError) {
    console.warn("Swap request created but failed to add offered reagent");
    return false;
  }
  
  return true;
};
